import { MsalProvider } from '@azure/msal-react';
import { Layout } from '@organisms/Layout';
import { initGA, logPageView, msalInstance, scrollTop } from '@utils';
import {
  Route,
  BrowserRouter as Router,
  Routes,
  useLocation,
} from 'react-router-dom';
import { useEffect } from 'react';
import {
  BeforeYouStart,
  Confirmation,
  DateTimeDetails,
  EmailConfirmationReport,
  IssueLocation,
  IssueType,
  UploadPhotoPage,
  VehicleDetails,
  YourDetails,
  ReportToTflPage,
} from './components/pages';
import { RoutesList, steps } from './routes/Routes';
import { basename } from './routes/basename';
import { InternalServerErrorTemplate, NotFoundErrorTemplate } from '@templates';

function App() {
  // It's important that the Router component is above the pages component because you'll need to use the useHistory hook before rendering MsalProvider
  useEffect(() => {
    initGA();
    logPageView();

    // Log page views on route change
    const logPageViewOnRouteChange = () => logPageView();
    window.addEventListener('popstate', logPageViewOnRouteChange);

    return () =>
      window.removeEventListener('popstate', logPageViewOnRouteChange);
  }, []);

  return (
    <Router basename={basename}>
      <RouteChangeTracker />
      <Pages />
    </Router>
  );
}

function Pages() {
  const location = useLocation();

  useEffect(() => {
    scrollTop();
  }, [location.pathname]);

  return (
    <MsalProvider instance={msalInstance}>
      <Layout steps={steps}>
        <Routes>
          <Route path={RoutesList.PARKING_HOME} element={<BeforeYouStart />} />
          <Route path={RoutesList.ISSUE_TYPE} element={<IssueType />} />
          <Route
            path={RoutesList.VEHICLE_DETAILS}
            element={<VehicleDetails />}
          />
          <Route path={RoutesList.UPLOAD_PHOTO} element={<UploadPhotoPage />} />
          <Route path={RoutesList.ISSUE_LOCATION} element={<IssueLocation />} />
          <Route
            path={RoutesList.REPORT_TO_TFL}
            element={<ReportToTflPage />}
          />
          <Route
            path={RoutesList.DATETIME_DETAILS}
            element={<DateTimeDetails />}
          />
          <Route path={RoutesList.YOUR_DETAILS} element={<YourDetails />} />
          <Route
            path={RoutesList.EMAIL_CONFIRMATION_REPORT}
            element={<EmailConfirmationReport />}
          />
          <Route path={RoutesList.CONFIRMATION} element={<Confirmation />} />
          <Route
            path={RoutesList.INTERNAL_SERVER_ERROR}
            element={<InternalServerErrorTemplate />}
          />
          <Route
            path={RoutesList.NOT_FOUND}
            element={<NotFoundErrorTemplate />}
          />
        </Routes>
      </Layout>
    </MsalProvider>
  );
}

// Component to track route changes and log page views
export const RouteChangeTracker = () => {
  const location = useLocation();

  useEffect(() => {
    logPageView();
  }, [location]);

  return null;
};

export default App;
